import './style.css';
import { Game } from './game/Game';

const canvas = document.querySelector<HTMLCanvasElement>('#view');
const ui = document.querySelector<HTMLElement>('#ui');

if (!canvas || !ui) {
  throw new Error('A página do jogo está incompleta.');
}

const game = new Game(canvas, ui);
void game.start().catch((error: unknown) => {
  console.error(error);
  ui.innerHTML = '<section class="panel fatal"><h1>Supermarket Kart Racing</h1><p>Não foi possível iniciar o jogo.</p></section>';
});
